module.exports = __webpack_public_path__ + "static/img/02.5b4dd67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Products/ProductList/images/02.jpg
// module id = 95yg
// module chunks = 1